import fc from '@/firebaseConfig'
import firebase from "firebase/app";
// import algoliasearch from "algoliasearch";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
const _ = require('lodash');

export default {
  namespaced: true,
  state: {
    list: [],
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    docList:[],
    summaryReport:{},
    orderBySelect: {key: 'paymentDocDate', value: 'desc'},
    valueFilterList: ["@DownloadedXml", "not-download"],
    selectedList: [],
    summaryAll: null,
    showPaginationTemplate: true,
    mPurchaseDocListUnsubscribeObject: null,
    mPurchaseSummaryAllUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setCompaniesDocs(state, val) {
      state.list = val
    },
    setPage(state, val) {
      state.page = val
    },
    setKeyword(state, val) {
      state.keyword = val
    },
    setEmptyList(state, val) {
      state.emptyList = val
    },
    setStackPage(state, val) {
      state.stackPage = val
    },
    setCurrentPageAlgolia(state, val) {
      state.currentPageAlgolia = val
    },
    setDocList(state, val) {
      state.docList = val
    },
    setSummaryReport(state, val) {
      state.summaryReport = val
    },
    setOrderBySelect(state, val) {
      state.orderBySelect = val
    },
    setValueFilterList(state, val) {
      state.valueFilterList = val
    },
    setSelectedList(state, val) {
      state.selectedList = val
    },
    setSummaryAll(state,val){
      state.summaryAll = val
    },
    setShowPaginationTemplate(state, val) {
      state.showPaginationTemplate = val
    }
  },
  actions: {
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".")
      if (documentType.length > 2) {
        return documentType[documentType.length - 1]
      }
      return ""
    },
    setLoading({commit}, val) {
      commit('setLoading', val)
    },
    async setDocsData({commit}, data) {
      if(data && data.length) {
        let pageLimit = localStorage.getItem("pageLimit")
        if (pageLimit === "auto"){
          pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10
        }else {
          pageLimit = parseInt(pageLimit) || 10
        }

        let docsList = data;
        let docs = []
        for(let doc of docsList) {
          doc = doc.node
          let timeSignedXml = null
          if(doc.timeSignedXml) {
            timeSignedXml = moment(doc.timeSignedXml)
          }
          console.log('setDoc')
          let d = {
            '@BuyerBranchID': doc.buyerBranchId,
            '@DocType': doc.docType,
            '@DownloadedXml': doc.downloadedXml,
            'ED.IssueDateTime': doc.edIssueDateTime,
            '@Errors': JSON.parse(JSON.parse(doc.errors)),
            // doc.mailSent,
            'objectID': doc.objectId,
            'SCTT.AHTA.BTP.ID': doc.scttAhtaBtpId,
            'SCTT.AHTA.BTP.Name': doc.scttAhtaBtpName,
            'SCTT.AHTA.BTP.STR.ID': doc.scttAhtaBtpStrId,
            'SCTT.AHTS.STSHMS.GrandTotalAmount': doc.scttAhtsStshmsGrandTotalAmount,
            'SCTT.AHTS.STSHMS.TaxBasisTotalAmount': doc.scttAhtsStshmsTaxBasisTotalAmount,
            'SCTT.AHTS.STSHMS.TaxTotalAmount': doc.scttAhtsStshmsTaxTotalAmount,
            '@SignedPdfUrl': doc.signedPdfUrl,
            '@SignedXmlUrl': doc.signedXmlUrl,
            '@TimeSignedXml': timeSignedXml,
            '@UnsignedPdfUrl': doc.unsignedPdfUrl,
          }
          docs.push(d)
        }

        let startVisible = docs[0];
        let lastVisible = docs[docs.length-1];

        let objectTmp = { first: _.cloneDeep(startVisible), last: _.cloneDeep(lastVisible)}
        let stackPage = _.cloneDeep(this.state.purchase.stackPage)
        stackPage[this.state.purchase.page] = objectTmp

        commit('setStackPage', stackPage)
        commit('setCompaniesDocs', docs)
        commit('setEmptyList', false)
        commit('setLoading', false)
      } else {
        commit('setCompaniesDocs', [])
        commit('setEmptyList', true)
      }
    },
    async getList({rootState, commit, dispatch}, {id, isNextPage}) {
      commit('setLoading', true)
      console.log('getlist')
      let pageLimit = localStorage.getItem("pageLimit")
      if (pageLimit === "auto"){
        pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10
      }else {
        pageLimit = parseInt(pageLimit) || 10
      }

      let documentType = await dispatch('getDocumentType')
      let documentTypeNumber = getDocumentTypeKey(documentType)
      let selectedBranch = rootState.companies.selectedBranch
      if (this.state.purchase.keyword) {
        // let client = algoliasearch("RD6OLUBOCH", "24a22f381826bcad0f255cfdfa7174f4");
        // let index = client.initIndex('Companies_' + id + '_Docs');
        //
        // if (isNextPage !== undefined) {
        //   let currentPageAlgoliaTmp = this.state.docs.currentPageAlgolia
        //   if (isNextPage) {
        //     currentPageAlgoliaTmp += 1
        //   } else {
        //     currentPageAlgoliaTmp -= 1
        //   }
        //   commit('setCurrentPageAlgolia', currentPageAlgoliaTmp)
        // }
        //
        // let filters = ""
        // if (documentTypeNumber) {
        //   filters = "@DocType:" + documentTypeNumber
        // }
        //
        //
        // if (selectedBranch) {
        //   if (filters.length > 0) {
        //     filters += " AND "
        //   }
        //   filters += "@SellerBranchID:" +  selectedBranch
        // }
        //
        // // Perform an Algolia search:
        // // https://www.algolia.com/doc/api-reference/api-methods/search/
        // index.search(this.state.docs.keyword, {
        //   page: this.state.docs.currentPageAlgolia,
        //   hitsPerPage: pageLimit,
        //
        //   filters: filters,
        //
        // }).then(function (responses) {
        //   responses.hits.forEach((doc) => {
        //     doc.id = doc.objectID
        //
        //     let timeKeyList = ['@TimeCreated', '@TimeSignedPdf', '@TimeSignedXml']
        //     timeKeyList.forEach((key) => {
        //       if (doc[key]) {
        //         doc[key] = new firebase.firestore.Timestamp(doc[key]._seconds, doc[key]._nanoseconds)
        //       }
        //     })
        //   })
        //
        //   commit('setPage', responses.page + 1)
        //   commit('setEmptyList', responses.nbPages === 1)
        //   commit('setCompaniesDocs', responses.hits)
        //   commit('setLoading', false)
        // });

      } else {
        const docs = fc.companies.doc(id)
          .collection("DocsPurchase")

        let query = docs
        if (this.state.purchase.orderBySelect && this.state.purchase.orderBySelect['key'] && this.state.purchase.orderBySelect['key'] !== "ID") {
          query = query.orderBy(new firebase.firestore.FieldPath(this.state.purchase.orderBySelect['key']), this.state.purchase.orderBySelect['value'])
        }

          if (this.state.purchase.valueFilterList.length > 0) {
          let downloaded = this.state.purchase.valueFilterList.includes('@DownloadedXml')
          let notDownload = this.state.purchase.valueFilterList.includes('not-download')
          if (downloaded && !notDownload) {
            query = query.where("@DownloadedXml", "==", true);
          }
          if (notDownload && !downloaded) {
            query = query.where("@DownloadedXml", "==", false);
          }
        }

        console.log(selectedBranch)
        console.log(documentTypeNumber)
        if (selectedBranch) {
          query = query.where("@SellerBranchID", "==", selectedBranch);
        }

        if (documentTypeNumber) {
          query = query.where("@DocType", "==", documentTypeNumber);
        }

        if (this.state.purchase.page > 1) {
          let listTmpPage
          if (isNextPage) {
            listTmpPage = this.state.purchase.stackPage[this.state.purchase.page - 1]
            query = query.startAfter(listTmpPage['last']).limit(pageLimit)
          } else {
            listTmpPage = this.state.purchase.stackPage[this.state.purchase.page]
            query = query.startAt(listTmpPage['first']).limit(pageLimit)
          }
        } else if (pageLimit) {
          query = query.limit(pageLimit)
        }

        if (this.state.mPurchaseDocListUnsubscribeObject) { this.state.mPurchaseDocListUnsubscribeObject() }
        this.state.mPurchaseDocListUnsubscribeObject = query.onSnapshot((documents) => {
          let documentsArray = []

          if (documents.size !== 0) {
            for (const doc of documents.docs) {
              let document = doc.data();
              document.id = doc.id;
              documentsArray.push(document);
            }

            let startVisible = documents.docs[0];
            let lastVisible = documents.docs[documents.docs.length-1];

            let objectTmp = { first: _.cloneDeep(startVisible), last: _.cloneDeep(lastVisible)}
            let stackPage = _.cloneDeep(this.state.purchase.stackPage)
            stackPage[this.state.purchase.page] = objectTmp

            commit('setStackPage', stackPage)
            commit('setCompaniesDocs', documentsArray)
            commit('setEmptyList', false)
          } else {
            commit('setCompaniesDocs', [])
            commit('setEmptyList', true)
          }
          commit('setLoading', false)
        });
      }
    },
    getDocListUnsubscribe() {
      if (this.state.mPurchaseDocListUnsubscribeObject) {
        this.state.mPurchaseDocListUnsubscribeObject()
        this.state.mPurchaseDocListUnsubscribeObject = null
      }
    },
    getListByMonth({commit}, {companyID, startDate, endDate, reportBranchType}){
      commit('setLoading', true)
      const fieldQuery = new firebase.firestore.FieldPath('ED.IssueDateTime.Timestamp')
      const docs = fc.companies.doc(companyID).collection("Docs")
      let query = docs

      query = query.where("@DownloadedXml", "==", true)

      if(startDate && endDate){
        query = query.where(fieldQuery, ">=", new Date(startDate)).where(fieldQuery, "<=", new Date(endDate))
      }

      if(reportBranchType){
        query = query.where("@SellerBranchID", "==", reportBranchType)
      }

      query.get().then(function (docs){
        let docList = []
        let summary = {
          sumTaxableAmount: 0.0,
          sumTaxableTax: 0.0,
          sumTaxableAllAmount: 0.0,

          sumAmount: 0.0, // รวมมูลค่าสินค้าที่ไม่มีภาษี
          sumTax: 0.0, // รวมภาษีที่ไม่มีภาษี (เป็น 0 เสมอ)
          sumAllAmount: 0.0, // รวมยอดสุดท้ายที่ไม่มีภาษี

          grandTotalAmount: 0.0, // รวมมูลค่าสินค้าทั้งหมด
          grandTotalTax: 0.0, // รวมภาษีทั้งหมด
          grandTotalAllAmount: 0.0 // รวมยอดสุดท้ายทั้งหมด
        };
        docs.forEach((doc) => {
          let docData = doc.data()
          docData.id = doc.id

          // case 4 ใบลดหนี้
          if (docData['@DocType'] === 4) {
            docData['SCTT.AHTS.STSHMS.TaxBasisTotalAmount'] *= -1
            docData['SCTT.AHTS.STSHMS.TaxTotalAmount'] *= -1
            docData['SCTT.AHTS.STSHMS.GrandTotalAmount'] *= -1
          }

          docList.push(docData)
          summary.grandTotalAmount += docData['SCTT.AHTS.STSHMS.TaxBasisTotalAmount']
          summary.grandTotalTax += docData['SCTT.AHTS.STSHMS.TaxTotalAmount']
          summary.grandTotalAllAmount += docData['SCTT.AHTS.STSHMS.GrandTotalAmount']
          if(docData['SCTT.AHTS.STSHMS.TaxTotalAmount'] && docData['SCTT.AHTS.STSHMS.TaxTotalAmount'] !== "0"){
            summary.sumTaxableAmount += docData['SCTT.AHTS.STSHMS.TaxBasisTotalAmount']
            summary.sumTaxableTax += docData['SCTT.AHTS.STSHMS.TaxTotalAmount']
            summary.sumTaxableAllAmount += docData['SCTT.AHTS.STSHMS.GrandTotalAmount']
          }else {
            summary.sumAmount += docData['SCTT.AHTS.STSHMS.TaxBasisTotalAmount']
            summary.sumAllAmount += docData['SCTT.AHTS.STSHMS.GrandTotalAmount']
          }

        });
        commit('setDocList', docList)
        commit('setLoading', false)
        commit('setSummaryReport', summary)
      })
    },
    updatePage({commit}, {page}) {
      commit('setPage', page)
    },
    updateKeyword({commit}, {keyword}) {
      commit('setCurrentPageAlgolia', 0)
      commit('setKeyword', keyword)
    },
    setOrderBySelect({commit}, {orderBySelect}){
      commit('setOrderBySelect', orderBySelect)
    },
    setValueFilterList({commit}, {valueFilterList}){
      commit('setValueFilterList', valueFilterList)
    },
    setSelectedList({commit}, {selectedList}){
      commit('setSelectedList', selectedList)
    },
    getSummaryAll({commit}, {companyId}) {
      if (this.state.mPurchaseSummaryAllUnsubscribeObject) { this.state.mPurchaseSummaryAllUnsubscribeObject() }
      this.state.mPurchaseSummaryAllUnsubscribeObject = fc.companies.doc(companyId).collection("Summaries").doc("all").onSnapshot(function (allSummaries) {
          commit('setSummaryAll', allSummaries.data())
        }
      )
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mPurchaseSummaryAllUnsubscribeObject) {
        this.state.mPurchaseSummaryAllUnsubscribeObject()
        this.state.mPurchaseSummaryAllUnsubscribeObject = null
      }
    },
    setShowPaginationTemplate({commit}, {val}) {
      commit('setShowPaginationTemplate', val)
    },
  },

}

export const docsQuery =  gql`
      query docs ($first: Int, $last: Int, $after: String, $before: String, $companyId: String!, $order:String, $search: String, $issueDateTimeRange: [DateTime], $objectId: String, $scttAhtaBtpId: String, $buyerBranchId: String, $typeLineTotal: String, $lineTotal: [Float], $typeTaxTotal: String, $taxTotal: [Float], $typeGrandTotal: String, $grandTotal: [Float], $timeSignedXmlRange: [DateTime], $docType: String, $downloadedXml: Boolean, $signSuccess: Boolean, $hasError: Boolean, $mailSent: Boolean, $suspendedAccount: Boolean, $buyerEmail_Isnull: Boolean){
        docs: allDocument(first: $first, after: $after, last: $last, before: $before, companyId: $companyId, order:$order, search:$search, issueDateTimeRange: $issueDateTimeRange, objectId: $objectId, scttAhtaBtpId: $scttAhtaBtpId, buyerBranchId: $buyerBranchId, typeLineTotal: $typeLineTotal, lineTotal: $lineTotal, typeTaxTotal: $typeTaxTotal, taxTotal: $taxTotal, typeGrandTotal: $typeGrandTotal, grandTotal: $grandTotal, timeSignedXmlRange: $timeSignedXmlRange, docType: $docType, downloadedXml: $downloadedXml, signSuccess: $signSuccess, hasError: $hasError, mailSent: $mailSent, suspendedAccount: $suspendedAccount, buyerEmail_Isnull: $buyerEmail_Isnull){
        totalCount
        edgeCount
          edges {
            node {
              id
              docType
              objectId
              edIssueDateTime
              scttAhtaBtpId
              scttAhtaBtpName
              scttAhtaBtpStrId
              buyerBranchId
              scttAhtsStshmsTaxBasisTotalAmount
              scttAhtsStshmsTaxTotalAmount
              scttAhtsStshmsGrandTotalAmount
              timeSignedXml
              mailSent
              downloadedXml
              signedXmlUrl
              signedPdfUrl
              unsignedPdfUrl
              errors
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    `
